var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container-fluid text-center footer",staticStyle:{"margin-bottom":"20px"}},[_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n\t\t"+_vm._s(_vm.$t('misc.license'))+" "),_c('a',{attrs:{"href":"https://tiefox.de/"}},[_vm._v("Tiefox.de")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112ec5f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/Footer.vue
// module id = null
// module chunks = 